import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { enrollableCoursesFilterFn } from '../utils/courseFilterUtil';
import { isImprovedCertEnrollmentsEnabled } from '../utils/experimentUtils';
import SessionJoinDialog from './SessionJoinDialog';
import { useCoursesContext } from './v2/CoursesProvider';
import { useDegreeContext } from './v2/DegreeHomeContext';

export const EnrollmentDialogContainer: React.VFC = () => {
  const { refetchCalendarItems } = useDegreeContext();
  const { showEnrollmentDialog, setShowEnrollmentDialog, upcomingCoursesData, coursesLoading, refetchCourses } =
    useCoursesContext();
  const router = useRouter();
  const enrollingCourseIdUrlParam = router.location.query.enrollingCourseId;
  const showEnrollmentDialogUrlParam = router.location.query.showEnrollmentDialog;

  const handleClose = () => {
    setShowEnrollmentDialog(false);
    const newQueryParams = { ...router.location.query };
    delete newQueryParams.enrollingCourseId;
    delete newQueryParams.showEnrollmentDialog;
    router.push({
      ...router.location,
      params: router.params,
      query: newQueryParams,
    });
  };

  const handleEnrollment = () => {
    if (refetchCourses) {
      refetchCourses();
    }

    if (refetchCalendarItems) {
      refetchCalendarItems();
    }
  };

  if (!isImprovedCertEnrollmentsEnabled()) return null;
  return (
    <SessionJoinDialog
      courseIds={upcomingCoursesData?.filter(enrollableCoursesFilterFn)?.map((course) => course.id) ?? []}
      courseIdsLoading={coursesLoading}
      isOpen={enrollingCourseIdUrlParam || showEnrollmentDialogUrlParam || showEnrollmentDialog}
      onClose={handleClose}
      enrollingCourseId={enrollingCourseIdUrlParam}
      onEnrolled={handleEnrollment}
    />
  );
};

export default EnrollmentDialogContainer;
